/**
 * Logging utilities that only show logs in development (localhost) environments
 */

// Check if the current environment is localhost
const isLocalhost = (): boolean => {
  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.includes("192.168.") ||
    window.location.hostname.includes(".local")
  );
};

// Store the original console methods
const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
  debug: console.debug,
};

// Create wrapper functions that only log in development
export const logger = {
  log: (message?: any, ...optionalParams: any[]): void => {
    if (isLocalhost()) {
      originalConsole.log(message, ...optionalParams);
    }
  },

  warn: (message?: any, ...optionalParams: any[]): void => {
    if (isLocalhost()) {
      originalConsole.warn(message, ...optionalParams);
    }
  },

  error: (message?: any, ...optionalParams: any[]): void => {
    // Always log errors, but with reduced information in production
    if (isLocalhost()) {
      originalConsole.error(message, ...optionalParams);
    } else {
      // In production, only log the error message without detailed params
      originalConsole.error(typeof message === "string" ? message : "An error occurred");
    }
  },

  info: (message?: any, ...optionalParams: any[]): void => {
    if (isLocalhost()) {
      originalConsole.info(message, ...optionalParams);
    }
  },

  debug: (message?: any, ...optionalParams: any[]): void => {
    if (isLocalhost()) {
      originalConsole.debug(message, ...optionalParams);
    }
  },
};

export default logger;
